import React, { useState, useEffect, useRef } from "react"
import internationalFlag from "@images/internationalFlag.png"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { slugMaterialName } from "@utils/helpers"
import { WEBSITE_GENERIC_LANGUAGES } from "@utils/localisation"

const Dropdown = ({
  countryList,
  allCountries,
  selectedCountry,
  material,
  language,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)
  const { t } = useTranslation()
  const sluggedMaterialName = material ? slugMaterialName(material) : ""

  let tidyUpCountryList = countryList
    .map(country => {
      return {
        flag: country.flags.png,
        name: country.name.common,
        languageCode: Object.keys(country.languages)[0],
      }
    })
    .sort((a, b) => {
      if (a.name < b.name) {
        return -1
      }
      if (a.name > b.name) {
        return 1
      }
      return 0
    })
  const selectedCountryObject = tidyUpCountryList.find(
    country => country.name === selectedCountry
  )

  /* International is a special case and always should appear last one of the country dropdown*/
  tidyUpCountryList = [
    ...tidyUpCountryList,
    { flag: internationalFlag, name: "International", languageCode: "en" },
  ]

  tidyUpCountryList = tidyUpCountryList.filter(
    country => country.name !== selectedCountry
  )

  const getFixedLinkPart = countryName => {
    return (
      "/scrap-metal-price" +
      (countryName.toLowerCase() !== "international"
        ? `/${slugMaterialName(countryName)}`
        : "") +
      (sluggedMaterialName ? `/${sluggedMaterialName}/` : "/")
    )
  }

  const getLink = country => {
    const officialLanguage = country.languageCode

    if (!WEBSITE_GENERIC_LANGUAGES.includes(officialLanguage))
      return `/${officialLanguage}${getFixedLinkPart(country.name)}`

    if (WEBSITE_GENERIC_LANGUAGES.includes(language))
      return (
        (language !== "en" ? `/${language}` : "") +
        getFixedLinkPart(country.name)
      )

    return getFixedLinkPart(country.name)
  }

  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  const handleClickOutside = event => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <div ref={dropdownRef} className="relative inline-block text-left ">
      <div>
        <button
          type="button"
          className="w-[327px] md:w-[260px] inline-flex justify-between items-center rounded-none border-b border-gray-300 px-0 md:px-[16px] py-2 bg-white text-sm font-medium text-gray-700 focus:outline-none"
          id="menu-button"
          aria-expanded="true"
          aria-haspopup="true"
          onClick={toggleDropdown}
        >
          <span className="flex items-center">
            <div className="w-[36px]">
              <img
                className="h-[20px]"
                src={
                  selectedCountryObject?.flag
                    ? selectedCountryObject.flag
                    : internationalFlag
                }
                alt={selectedCountry}
              />
            </div>
            <span className="ml-2 font-inter  text-[16px] font-normal leading-[20px] tracking-[0.15px] text-dblue">
              {t(selectedCountry)}
            </span>
          </span>
          <svg
            className="ml-2 -mr-1 h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M5.23 7.21a.75.75 0 011.06.02L10 10.586l3.71-3.354a.75.75 0 011.04 1.08l-4 3.75a.75.75 0 01-1.04 0l-4-3.75a.75.75 0 01.02-1.06z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>

      {isOpen && (
        <div
          className="origin-top-left absolute left-0 mt-2 w-[260px] rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="menu-button"
        >
          <div className="py-1" role="none">
            {tidyUpCountryList.map(country => {
              const completeCountryInfo = allCountries.find(
                obj => obj.name === country.name
              )

              const countryLink = getLink(completeCountryInfo)

              return (
                <a
                  key={country.name}
                  href={countryLink}
                  className="text-gray-700  px-4 py-2 text-sm flex gap-[10px]"
                  role="menuitem"
                >
                  <div className="w-[36px]">
                    <img
                      className="h-[20px]"
                      src={country.flag}
                      alt={country.name}
                    />
                  </div>
                  {t(country.name)}
                </a>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default Dropdown
